import { render } from "./c-switcher.vue?vue&type=template&id=4844e9be&scoped=true"
import script from "./c-switcher.vue?vue&type=script&lang=js"
export * from "./c-switcher.vue?vue&type=script&lang=js"

import "./c-switcher.vue?vue&type=style&index=0&id=4844e9be&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4844e9be"]])

export default __exports__